import React from 'react';

const experienceData = [
  {
    id: 1,
    header: "Industries",
    content: ["Telcommunications", "Renewable Energy", "EdTech"]
  },
  {
    id: 2,
    header: "Companies",
    content: [ "Enphase Energy","Bharti Airtel", "ArcTech Labs", "Flipkart", "LG", "Fruitilicious"]
  },
  {
    id: 3,
    header: "Feature Areas",
    content: ["Onboarding userflow", "Project Management", "UI Revamp","Computer vision integration", "3D Design", "API platform", "Third party integrations"]
  },
  {
    id: 4,
    header: "Software types",
    content: ["Web apps", "Android apps","Internal tools", "Touch table apps", "B2B SaaS", "B2C apps"]
  },
  {
    id: 5,
    header: "Hard skills",
    content: ["Product vision", "Product Roadmap", "Customer centric UI/UX design", "Product Analytics","Market Research & Analysis", ]
  },
  {
    id: 6,
    header: "Soft skills",
    content: ["Innovation", "Leadership", "Effective Communication","Critical Thinking","Cross-Functional Collaboration"]
  },
  {
    id: 7,
    header: "Tools",
    content: ["JIRA", "MS-Office", "Confluence", "Figma", "Salesforce", "Google Analytics"]
  },
]


export default function Experience() {

  return (
    <div>
      {experienceData.map((data) => (
        <div id={data.id} className='experience-tile'>
          <p className='exp-header'>{data.header}</p>
          <ul className='exp-list'>
          {data.content.map((item) => (
            <li className='exp-list-item'>{item}
            </li>
          ))}
          </ul>
        </div>))}
    </div>
  );


}

